import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  schemaData?: Record<string, unknown>[] | Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = 'website',
  schemaData,
}: SEOHeadProps) {
  const location = useLocation();
  const baseUrl = 'https://baijiezhuan.com';

  const pageSchemas = useMemo(() => {
    const schemas: Record<string, unknown>[] = [];

    if (schemaData) {
      if (Array.isArray(schemaData)) {
        schemas.push(...schemaData);
      } else {
        schemas.push(schemaData);
      }
    }

    return schemas;
  }, [schemaData]);

  const canonicalUrl = canonicalPath ? `${baseUrl}${canonicalPath}` : `${baseUrl}${location.pathname}`;

  return (
    <>
      {title && (
        <>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta name="twitter:title" content={title} />
        </>
      )}
      {description && (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
          <meta name="twitter:description" content={description} />
        </>
      )}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      {pageSchemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}